module.exports = __webpack_public_path__ + "media/images/photo/top/album/album6-d9e5b117a5ad7e14f0323582682dee97.jpg";